import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'datePlusGMTPipe'
})
export class DatePlusGMTPipe implements PipeTransform {

    constructor(private datePipe: DatePipe) {
    }

    transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string {
        const date = new Date(value);
        const hourOffset = date.getTimezoneOffset() / -60;
        const result = this.datePipe.transform(value, format, timezone, locale);
        return result
            ? (result.includes('GMT') ? result : this.addGMTString(result, hourOffset))
            : '';
    }

    addGMTString(dateString: string, hourOffset: number): string {
        let hourOffsetString: string;
        // if there are minutes Offset
        if (Number.isInteger(hourOffset)) {
            hourOffsetString = `${hourOffset}`;
        } else {
            const minutesOffset = ((hourOffset % 1) * 60 > 0) ? (hourOffset % 1) * 60 : (hourOffset % 1) * -60;
            hourOffsetString = `${Math.trunc(hourOffset)}:${minutesOffset}`;
        }
        return `${dateString}, GMT${hourOffset < 0 ? '' : '+'}${hourOffsetString}`;
    }
}
